import React from 'react'
import BackgroundWrapper from '../components/wrapper'
import Card from '../components/card'
import { Footer } from '../components/layouts/footer'
import Button from '../components/button'
import { LogoIcon } from '../assets/icon'


const NotFound = () => {
    return (
        <BackgroundWrapper>
            <main className="flex items-center justify-center px-4  lg:px-20 py-6">
                <div className="w-full">
                    <div className="flex items-center justify-between  gap-2 mb-6">
                        <LogoIcon />

                    </div>

                    <div className="max-w-md mx-auto">

                        <Card>
                            <h2 className="text-[36px] text-[#121212] font-bold text-center mb-4">
                                Error 404
                            </h2>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets%2F3b1072ee4ebe466380c75002669f8b56%2F7857a44c60f5429f82d8aa53a84ac04f?format=webp&width=800"
                                alt="img"
                                className="mt-7"
                            />
                            <h2 className="text-[28px] text-[#121212] font-bold text-center mb-4">
                                Page Not Found
                            </h2>
                            <p className="text-[#12121299] text-[14px] text-center mt-4">
                                We have looked everywhere, but couldn’t find the page you were looking for.
                            </p>

                            <Button
                                href='/'
                                variant="primary"
                                size="lg"
                                className="w-full mt-3 flex"
                            >
                                Go Back to Homepage
                            </Button>
                        </Card>


                    </div>
                </div>
            </main>

            <Footer />
        </BackgroundWrapper>
    )
}

export default NotFound